import { useEffect } from 'react';

/**
 * Locks background page scrolling while a full-screen overlay is mounted.
 *
 * Uses the same reference-counted `hwScrollLock*` dataset keys as the inline
 * lock in ListFlightPage / FareViewsComponent, so nested overlays (a loader
 * opening while a popup is already open) unlock in the right order instead of
 * the first one to close releasing the page for everyone.
 *
 * @param {boolean} active pass false to leave the page scrollable
 */
export const useBodyScrollLock = (active = true) => {
    useEffect(() => {
        if (!active || typeof document === 'undefined') return undefined;

        const body = document.body;
        const currentCount = Number(body.dataset.hwScrollLockCount || '0');
        if (currentCount === 0) {
            body.dataset.hwScrollLockOverflow = body.style.overflow || '';
            body.style.overflow = 'hidden';
        }
        body.dataset.hwScrollLockCount = String(currentCount + 1);

        return () => {
            const count = Number(body.dataset.hwScrollLockCount || '0');
            const nextCount = Math.max(0, count - 1);
            body.dataset.hwScrollLockCount = String(nextCount);
            if (nextCount === 0) {
                body.style.overflow = body.dataset.hwScrollLockOverflow || '';
                delete body.dataset.hwScrollLockOverflow;
            }
        };
    }, [active]);
};

export default useBodyScrollLock;
